import { render } from "./BasePagerView.vue?vue&type=template&id=0968a01a"
import script from "./BasePagerView.vue?vue&type=script&lang=js"
export * from "./BasePagerView.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__